export default __webpack_public_path__ + "static/kv-banner-lt-jp-d86355a6fbf531b16e2ecd28bafce914.png";